export function isAuthorized($auth) {

	"ngInject";

	return () => $auth.isAuthenticated();

}


// WEBPACK FOOTER //
// ./sources/filters/isAuthorized.js